/**
 * Safely extract a human-readable string from an Axios error response.
 *
 * FastAPI can return `detail` as:
 *  - a plain string  → return it directly
 *  - a Pydantic v2 array of objects  → join the `msg` fields
 *  - something else  → fall back to `fallback`
 */
export function getErrorMessage(err, fallback = '操作失敗') {
  const detail = err?.response?.data?.detail;
  if (!detail) return fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map(d => (typeof d === 'string' ? d : d.msg || JSON.stringify(d))).join('; ');
  }
  if (typeof detail === 'object') {
    return detail.msg || JSON.stringify(detail);
  }
  return fallback;
}
